export const MOVIE_PREVIEW_DETAILS = [
  {
    id: 811634,
    name: "The Monkey King: Reborn",
    description:
      "When the irritable monkey king visits a temple together with his master Tang Monk, he feels offended because of a trifle",
    genere: ["Animation", "Action", "Fantasy", "Family"],
    video_id: "mjj3L35IKT0",
    img: "https://image.tmdb.org/t/p/w500/jDjmnEuNUfWHg8rbW6u8mylkcO0.jpg",
  },
  {
    id: 354912,
    name: "Coco",
    description:
      "Despite his family’s baffling generations-old ban on music, Miguel dreams of becoming an accomplished musician like his",
    genere: ["Family", "Animation", "Music", "Adventure"],
    video_id: "_TLXORFumu0",
    img: "https://image.tmdb.org/t/p/w500/askg3SMvhqEl4OL52YuvdtY40Yb.jpg",
  },
  {
    id: 508442,
    name: "Soul",
    description:
      "Joe Gardner is a middle school teacher with a love for jazz music. After a successful audition at the Half Note Club, he",
    genere: ["Animation", "Family", "Comedy", "Fantasy"],
    video_id: "Gs--6c7Hn_A",
    img: "https://image.tmdb.org/t/p/w500/rQaHA74pevnGsxcKGaoZVGWe9TC.jpg",
  },
  {
    id: 284053,
    name: "Thor: Ragnarok",
    description:
      "Thor is imprisoned on the other side of the universe and finds himself in a race against time to get back to Asgard to s",
    genere: ["Action", "Adventure", "Science Fiction"],
    video_id: "ue80QwXMRHg",
    img: "https://image.tmdb.org/t/p/w500/jsoz1HlxczSuTx0mDl2h0lxy36l.jpg",
  },
];
